export {
	DMS_MODULE, API_ND_AREA,
} from '../constants';
export const NAME = 'NdSkladPreceneni';
export const CRUMB_LABEL_KEY = 'edtNDSkladprec';
